module.exports = __webpack_public_path__ + "img/1.0ebd973f.jpg";